<template>
  <div class="h-screen flex flex-col">
    <common-nav :show-cart="false"></common-nav>
    <div class="flex-grow">
      <router-view></router-view>
    </div>
    <footer-outfitter></footer-outfitter>
  </div>
</template>

<script>
import CommonNav from "@/components/ui/nav/CommonNav";
import FooterOutfitter from "@/components/ui/footer/FooterOutfitter";

export default {
  name: "Cart",
  components: {
    FooterOutfitter,
    CommonNav,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {
    this.$store.dispatch("search/get_outfitter", this.$route.params.slug);
  },
};
</script>
